import "./ActivitiesMain.scss";
import React from 'react';
import { getImageUrl } from '../../utils/imageAssets';

const ActivitiesMain = () => {
return (
    <section className="about-acts__section">
    <div className="about-acts__sectionHead">
        <h2 className="about-acts__h2">주요 활동</h2>
        <p className="about-acts__desc">한눈에 이해할 수 있도록 핵심만 정리했어요.</p>
    </div>

    <div className="about-acts__grid">
        <article className="act">
        <div className="act__media" aria-hidden="true">
            <img className="act__img" src={getImageUrl('/images/activities/01.jpeg')} alt="" loading="lazy" decoding="async" />
            <div className="act__overlay" />
            <div className="act__badge">Tour</div>
        </div>

        <div className="act__body">
            <h3 className="act__title">캠퍼스 투어 운영</h3>
            <p className="act__lead">방문객에게 GIST의 연구·생활 공간을 안내하고, 캠퍼스의 분위기를 직접 전달합니다.</p>

            <ul className="act__points" aria-label="캠퍼스 투어 운영 핵심">
            <li className="act__point">
                <span className="act__dot" aria-hidden="true" />
                정기 투어 운영
            </li>
            <li className="act__point">
                <span className="act__dot" aria-hidden="true" />
                주요 시설/동선 안내
            </li>
            <li className="act__point">
                <span className="act__dot" aria-hidden="true" />
                방문 목적 맞춤 안내
            </li>
            </ul>
        </div>
        </article>

        <article className="act">
        <div className="act__media" aria-hidden="true">
            <img className="act__img" src={getImageUrl('/images/activities/004.jpg')} alt="" loading="lazy" decoding="async" />
            <div className="act__overlay" />
            <div className="act__badge">Outreach</div>
        </div>

        <div className="act__body">
            <h3 className="act__title">입시 설명회</h3>
            <p className="act__lead">GIST 입학 정보에 대해 소개하는 시간을 갖고, 재학생의 시선으로 실제 정보를 제공합니다.</p>

            <ul className="act__points" aria-label="입시 설명회·고교 방문 핵심">
            <li className="act__point">
                <span className="act__dot" aria-hidden="true" />
                설명회 참여
            </li>
            <li className="act__point">
                <span className="act__dot" aria-hidden="true" />
                질의응답 지원
            </li>
            <li className="act__point">
                <span className="act__dot" aria-hidden="true" />
                입시/학사 기본 안내
            </li>
            </ul>
        </div>
        </article>

        <article className="act">
        <div className="act__media" aria-hidden="true">
            <img className="act__img" src={getImageUrl('/images/activities/01.jpg')} alt="" loading="lazy" decoding="async" />
            <div className="act__overlay" />
            <div className="act__badge">Media</div>
        </div>

        <div className="act__body">
            <h3 className="act__title">SNS 콘텐츠 제작</h3>
            <p className="act__lead">영상·카드뉴스로 GIST의 일상과 정보를 더 쉽고 빠르게 전합니다.</p>

            <ul className="act__points" aria-label="SNS 콘텐츠 제작 핵심">
            <li className="act__point">
                <span className="act__dot" aria-hidden="true" />
                영상/카드뉴스 제작
            </li>
            <li className="act__point">
                <span className="act__dot" aria-hidden="true" />
                SNS 운영
            </li>
            <li className="act__point">
                <span className="act__dot" aria-hidden="true" />
                콘텐츠 기획
            </li>
            </ul>
        </div>
        </article>

        <article className="act">
        <div className="act__media" aria-hidden="true">
            <img className="act__img" src={getImageUrl('/images/activities/02.jpeg')} alt="" loading="lazy" decoding="async" />
            <div className="act__overlay" />
            <div className="act__badge">Event</div>
        </div>

        <div className="act__body">
            <h3 className="act__title">교내·외 공식 행사 지원</h3>
            <p className="act__lead">공식 행사에서 안내·운영을 지원하며, 대외 협력 행사도 함께 진행합니다.</p>

            <ul className="act__points" aria-label="교내·외 공식 행사 지원 핵심">
            <li className="act__point">
                <span className="act__dot" aria-hidden="true" />
                행사 운영 지원
            </li>
            <li className="act__point">
                <span className="act__dot" aria-hidden="true" />
                안내/동선 관리
            </li>
            <li className="act__point">
                <span className="act__dot" aria-hidden="true" />
                대외 협력 지원
            </li>
            </ul>
        </div>
        </article>
    </div>
    </section>
);
};

export default ActivitiesMain;
